export default __webpack_public_path__ + "static/vitalize_logo_cropped-245e0df379eb0800f73db39799425fed.png";